export default {
  newDesign: true,
  parameters: {
    landing_id: "BrQuScoG",
    segment: 42,
    success_page: "success_long",
  },
  title:
    "Receba uma aula experimental de programação personalizada para o seu filho! | Kodland",
  downtimeUrl: "https://www.kodland.org/pt",
  startPage: {
    title:
      "Responda a estas perguntas e ganhe uma aula experimental para seu filho/a!",
    subtitle:
      "📕 Aulas para crianças de 8 a 17 anos<br>💻 Só precisa de um computador e acesso à internet<br>💙 Já escolhido por mais de 200.000 pais",
    image: {
      url: "/welcome/brazil_scoring_google_desk.png",
      style: {
        height: "100%",
        "max-height": "100vh",
      },
    },
    imageMobile: {
      url: "/welcome/brazil_scoring_google_mob.png",
      style: {
        width: "100%",
      },
    },
    button: "Começar →",
  },
  stopPage: {
    image: "/welcome/quizV2/no-computer.png",
    title: "Obrigado por confiar em nossa plataforma educacional!",
    subtitle:
      "Infelizmente, tablets ou telefones não são adequados para assistir às nossas aulas. Ficaremos felizes em vê-lo em nossas aulas na próxima vez!",
  },
  customStopPages: {
    internet: {
      title: "Obrigado por confiar na nossa plataforma educacional!",
      subtitle:
        "Infelizmente, nossas aulas precisam de uma conexão de internet estável e rápida para funcionar corretamente. Por favor, verifique sua conexão antes de tentar novamente. Esperamos ver você em nossas aulas em breve!",
      image: "/welcome/quizV2/no-computer.png",
    },
    child: {
      title: "Obrigado por confiar na nossa plataforma educacional!",
      subtitle:
        "Infelizmente, apenas um pai, mãe ou responsável pode fazer o cadastro para as aulas. Por favor, envie o link do nosso site para seus pais, se quiser continuar. Estamos ansiosos para ver você em nossas aulas!",
      image: "/welcome/quizV2/child-parent.png",
    },
  },
  quizRotateBySteps: {
    1: {
      question: "Você é pai, mãe ou filho/a?",
      answers: [
        "Pai",
        "Mãe",
        {
          answer: "Filho(a)",
          redirectToBackupForm: true,
        },
      ],
    },
    2: {
      title: "Quantos anos tem seu filho/a?",
      type: "age",
      button: "",
    },
    3: {
      question: "O que seu filho gosta de fazer no tempo livre?",
      answers: [
        "Praticar esportes ou brincar ao ar livre ⚽",
        "Ler livros ou quadrinhos 📚",
        "Assistir TV, YouTube ou jogar videogames 🎮",
        "Passar tempo com amigos ou familiares 👫",
        "Outro 🙂",
      ],
    },
    4: {
      question: "Como seu filho se sente em relação ao aprendizado online?",
      answers: [
        "Eles adoram e acham envolvente 💻❤️",
        "Preferem o aprendizado presencial 🙂",
        "Eles têm dificuldade para manter o foco 😵‍💫",
        "Eles nunca tentaram aprender online ❓",
      ],
    },
    5: {
      typeInfo: "noQuestions",
      imageLink: "/welcome/brazil_graph.webp",
      subtitle:
        "Embora seja recomendado que as crianças não passem mais de 2 horas por dia em dispositivos, na América Latina frequentemente ultrapassam as 5 horas. É aconselhável alternar entretenimento com atividades produtivas, como aulas de 1 a 1,5 horas.<br><br>Nossos programas foram projetados com isso em mente.",
      button: "Muito bem",
    },
    6: {
      question: "Na escola, o que seu filho mais gosta de fazer? ",
      answers: [
        "Experimentos de ciências ou desafios de matemática 🧪🔢",
        "Ler e escrever histórias 📚✍️",
        "Arte, música ou atividades criativas 🎨🎶",
        "Educação física ou esportes 🏃‍♀️🏋️‍♂️",
        "Outro 🙂",
      ],
    },
    7: {
      question:
        "Seu filho gosta de construir ou projetar coisas (por exemplo, com Lego, arte, quebra-cabeças)?",
      answers: [
        "Sim, ele adora construir e projetar coisas 🧩🏗️",
        "Às vezes, mas ele prefere outras atividades 🤔",
        "Não, ele não tem muito interesse nisso 🙅‍♂️",
      ],
    },
    8: {
      question: "Como seu filho aprende ou lembra melhor das coisas novas?",
      answers: [
        "Vendo (aprende de forma visual) 👁️",
        "Fazendo (aprende praticando) 👐",
        "Ouvindo (aprende auditivamente) 🎧",
        "Através de repetição e prática 🔄✏️",
      ],
    },
    9: {
      question: "Seu filho tem acesso a um laptop ou computador para estudar?",
      answers: [
        "Sim, ele tem o próprio dispositivo 💻✅",
        "Sim, mas ele compartilha com outras pessoas 🖥️👫",
        {
          answer: "Não, ele não tem acesso regular 🚫",
          stopAnswer: true,
        },
      ],
    },
    10: {
      question: "Quais atividades atraem seu filho?",
      answers: [
        "Esportes ou dança ⚽💃",
        "Artes criativas 🎨🖌️",
        "Atividades intelectuais 🧩♟️💻",
        "Jogos ou vídeos 🎮📺",
        "Outro 🙂",
      ],
    },
    11: {
      question: "Como seu filho trabalha em grupo?",
      answers: [
        "Gosta de colaborar 🤝💡",
        "Prefere liderar 🧑‍⚖️",
        "Trabalha de forma independente, mas contribui 👤✔️",
        "Fica tímido ou desconfortável 😳",
      ],
    },
    12: {
      question:
        "Qual papel seu filho costuma desempenhar em atividades de grupo?",
      answers: [
        "Ele gosta de liderar e organizar 🧑‍⚖️🗂️",
        "Ele gosta de contribuir com ideias e colaborar 🤝💡",
        "Prefere ouvir e seguir 👂🙂",
        "Tenta mediar ou resolver conflitos ⚖️🕊️",
        "Ele se sente tímido e fica no fundo 😳",
      ],
    },
    13: {
      typeInfo: "noQuestions",
      imageLink: "/welcome/quiz_br_2.webp",
      subtitle:
        "Oferecemos formatos de aprendizado tanto individuais quanto em grupo, adaptando cuidadosamente o processo para atender à idade e às necessidades de cada criança.",
      button: "Vamos lá!",
    },
    14: {
      question:
        "Seu filho já demonstrou interesse em aprender a programar ou codificar?",
      answers: [
        "Sim, já começou a aprender 💻🚀",
        "Sim, tem curiosidade, mas ainda não tentou 🤔💡",
        "Ainda não, mas talvez se interesse 🤷‍♂️",
        "Não, não está interessado 🙅‍♀️",
      ],
    },
    15: {
      question: "Qual é o gênero do seu filho?",
      answers: ["Masculino 👦", "Feminino 👧", "Prefiro não dizer 🤐"],
    },
    16: {
      question: "Quais atividades ou matérias seu filho mais gosta?",
      answers: [
        "Leitura ou escrita 📚✍️",
        "Arte, música ou teatro 🎨🎶🎭",
        "Esportes ou atividades físicas 🏃‍♀️⚽",
        "Tecnologia ou computadores 💻📱",
        "Outro 🙂",
      ],
    },
    17: {
      question:
        "Seu filho gosta de criar coisas ou fazer atividades com amigos?",
      answers: [
        "Sim, adora projetos criativos em grupo 👫🎨",
        "Às vezes, depende da atividade 🤔",
        "Não, prefere tarefas individuais 👤💡",
      ],
    },
    18: {
      question: "Seu filho está confortável com tecnologia?",
      answers: [
        "Muito confortável, usa frequentemente 💻✔️",
        "Consegue tarefas básicas, mas precisa de orientação 🖱️❓",
        "Não está familiarizado 🚫",
      ],
    },
    19: {
      typeInfo: "noQuestions",
      imageLink: "/welcome/brazil_fwd.webp",
      subtitle:
        "Na Kodland, os alunos projetam modelos 3D, criam quadrinhos, constroem jogos e desenvolvem programas de computador. Atualmente, 30.000 crianças em todo o mundo estão aprendendo conosco!",
      button: "Ótimo!",
    },
    20: {
      question: "Como seu filho lida com desafios ou problemas?",
      answers: [
        "Ele tenta resolver sozinho 💪🧠",
        "Pede ajuda quando necessário 🙋‍♀️✔️",
        "Fica frustrado e desiste facilmente 😤",
        "Gosta de resolver problemas e vê isso como um desafio 🕵️‍♂️",
      ],
    },
    21: {
      question:
        "Seu filho tem interesse em criar suas próprias histórias ou personagens?",
      answers: [
        "Sim, ele adora contar histórias e tem muitas ideias ✍️🌟",
        "Às vezes, mas precisa de incentivo 🤗",
        "Não, ele não tem muito interesse nisso 🚫",
      ],
    },
    22: {
      question:
        "Como seu filho lida com tarefas que exigem atenção e pensamento lógico?",
      answers: [
        "Ele é bom em se concentrar e resolver problemas 🎯🧩",
        "Se sai bem com alguma orientação ou estrutura 🗂️🤝",
        "Dificuldade em focar em tarefas detalhadas 😵‍💫",
      ],
    },
    23: {
      question: "Quando seu filho conta uma história, ele tende a...",
      answers: [
        "Focar em muitos detalhes e descrições 📝📜",
        "Ir direto ao ponto principal 🎯",
        "Adicionar humor ou imaginação à história 🤪✨",
        "Lutar para organizar seus pensamentos 🤔",
      ],
    },
    24: {
      question: "Como seu filho normalmente reage ao tentar algo novo?",
      answers: [
        "Ele mergulha de cabeça com entusiasmo 🎉🚀",
        "Fica curioso, mas cauteloso 🤔👣",
        "Fica nervoso e precisa de incentivo 😬🤗",
        "Adora experimentar por conta própria 🛠️🔬",
        "Resiste a tentar coisas novas 🙅‍♂️",
      ],
    },
    25: {
      question:
        "Seu filho prefere seguir instruções ou criar suas próprias ideias?",
      answers: [
        "Ele adora instruções claras e completar tarefas 📋✔️",
        "Prefere ideias criativas e novas abordagens 🎨💡",
        "Fica nervoso e precisa de incentivo 😬🤗",
        "Gosta de uma mistura de estrutura e liberdade ⚖️🛠️",
        "Depende da tarefa – estrutura ou criatividade 🤷‍♂️",
      ],
    },
    26: {
      typeInfo: "noQuestions",
      imageLink: "/welcome/brazil_review.webp",
      subtitle:
        "Somos recomendados por pais de todo o mundo. Esperamos que em breve você se junte a eles 💙",
      button: "Estamos quase lá",
    },
    27: {
      question: "O que motiva seu filho a manter o foco em uma tarefa?",
      answers: [
        "Um objetivo claro ou recompensa no final 🎯🏅",
        "Empolgação ou paixão pela tarefa ✨❤️",
        "Trabalhar em grupo 🤝💬",
        "Feedback positivo ou incentivo durante o processo 👏😊",
        "Um senso de competição ou desafio 🥇🔥",
      ],
    },
    28: {
      question:
        "Sobre o que seu filho gosta de falar em suas histórias ou tópicos?",
      answers: [
        "Aventuras, mistérios ou fantasia 🗺️🐉",
        "Ciência, tecnologia ou invenções 🔬💻",
        "Histórias engraçadas ou bobas 🤪😂",
        "Eventos reais ou história 📜🌍",
        "Histórias sobre amizades ou emoções ❤️👫",
      ],
    },
    29: {
      question: "O que faz seu filho se sentir orgulhoso ou realizado?",
      answers: [
        "Completar uma tarefa desafiadora 🏆🧠",
        "Ajudar os outros ou contribuir 🤝❤️",
        "Aprender algo novo 📚✨",
        "Receber feedback positivo 🥳👏",
        "Resolver um problema complicado 🔍🧩",
      ],
    },
    30: {
      question: "Em que tipo de escola seu filho estuda?",
      answers: [
        "Pública 🍎",
        "Privada 🏫",
        "Internacional / Bilíngue 🌎",
        "Homeschooling 🏡",
      ],
    },
    31: {
      question: "Quais são as matérias preferidas do seu filho na escola?",
      answers: [
        "Ciências ou matemática 🧪",
        "Arte, música ou atividades criativas 🎨",
        "Educação física ou esportes 🥇",
        "Outro 😊",
      ],
    },
    32: {
      question: "Qual é o nível de escolaridade mais alto na sua família?",
      answers: [
        "Mestrado / superior 🎓",
        "Licenciatura 🎓",
        "Ensino médio 🏫",
        "Ensino técnico / pré-vestibular 📚",
      ],
    },
    33: {
      question:
        "Quantos dispositivos (computador, celular ou tablet) seu filho pode usar em casa?",
      answers: ["0 – Não possui", "1 dispositivo", "2 ou mais dispositivos"],
    },
    34: {
      question: "Que tipo de acesso à internet vocês têm em casa?",
      answers: [
        "Internet de alta velocidade (fibra)",
        {
          answer: "Internet básica (ADSL)",
          redirectToBackupForm: true,
        },
        {
          answer: "Apenas dados móveis",
          redirectToBackupForm: true,
        },
        {
          answer: "Não temos acesso confiável",
          redirectToBackupForm: true,
        },
      ],
    },
    35: {
      question:
        "Quando você gostaria que seu filho começasse as aulas de programação?",
      answers: [
        "Esta semana",
        {
          answer: "Em 2–4 semanas",
          redirectToBackupForm: true,
        },
        {
          answer: "Em 1–3 meses",
          redirectToBackupForm: true,
        },
        {
          answer: "Apenas explorando",
          redirectToBackupForm: true,
        },
      ],
    },
    36: {
      question:
        "Você tem um computador de mesa ou notebook que seu filho possa usar para estudar?",
      answers: [
        "💻 Sim",
        {
          answer: "😞 Não",
          stopAnswer: true,
        },
      ],
    },
    37: {
      dynamicTypeInfo: [
        {
          condition: [
            {
              step: 30,
              answer: "Privada 🏫",
            },
            {
              step: 31,
              answer: "Ciências ou matemática 🧪",
            },
          ],
          data: {
            typeInfo: "congrats",
            title: "🎉 Tudo pronto para a aula gratuita do seu filho!",
            subtitle:
              "No próximo passo, preencha seus dados e escolha o melhor dia e horário para ele aproveitar a aula.",
            button: "📅 Agendar aula gratuita",
          },
        },
        {
          condition: [
            {
              step: 30,
              answer: "Internacional / Bilíngue 🌎",
            },
            {
              step: 31,
              answer: "Ciências ou matemática 🧪",
            },
          ],
          data: {
            typeInfo: "congrats",
            title: "🎉 Tudo pronto para a aula gratuita do seu filho!",
            subtitle:
              "No próximo passo, preencha seus dados e escolha o melhor dia e horário para ele aproveitar a aula.",
            button: "📅 Agendar aula gratuita",
          },
        },
        {
          condition: [
            {
              step: 30,
              answer: "Privada 🏫",
            },
            {
              step: 32,
              answer: "Mestrado / superior 🎓",
            },
          ],
          data: {
            typeInfo: "congrats",
            title: "🎉 Tudo pronto para a aula gratuita do seu filho!",
            subtitle:
              "No próximo passo, preencha seus dados e escolha o melhor dia e horário para ele aproveitar a aula.",
            button: "📅 Agendar aula gratuita",
          },
        },
        {
          condition: [
            {
              step: 30,
              answer: "Privada 🏫",
            },
            {
              step: 32,
              answer: "Licenciatura 🎓",
            },
          ],
          data: {
            typeInfo: "congrats",
            title: "🎉 Tudo pronto para a aula gratuita do seu filho!",
            subtitle:
              "No próximo passo, preencha seus dados e escolha o melhor dia e horário para ele aproveitar a aula.",
            button: "📅 Agendar aula gratuita",
          },
        },
        {
          condition: [
            {
              step: 30,
              answer: "Internacional / Bilíngue 🌎",
            },
            {
              step: 32,
              answer: "Mestrado / superior 🎓",
            },
          ],
          data: {
            typeInfo: "congrats",
            title: "🎉 Tudo pronto para a aula gratuita do seu filho!",
            subtitle:
              "No próximo passo, preencha seus dados e escolha o melhor dia e horário para ele aproveitar a aula.",
            button: "📅 Agendar aula gratuita",
          },
        },
        {
          condition: [
            {
              step: 30,
              answer: "Internacional / Bilíngue 🌎",
            },
            {
              step: 32,
              answer: "Licenciatura 🎓",
            },
          ],
          data: {
            typeInfo: "congrats",
            title: "🎉 Tudo pronto para a aula gratuita do seu filho!",
            subtitle:
              "No próximo passo, preencha seus dados e escolha o melhor dia e horário para ele aproveitar a aula.",
            button: "📅 Agendar aula gratuita",
          },
        },
        {
          condition: [
            {
              step: 30,
              answer: "Privada 🏫",
            },
            {
              step: 33,
              answer: "2 ou mais dispositivos",
            },
          ],
          data: {
            typeInfo: "congrats",
            title: "🎉 Tudo pronto para a aula gratuita do seu filho!",
            subtitle:
              "No próximo passo, preencha seus dados e escolha o melhor dia e horário para ele aproveitar a aula.",
            button: "📅 Agendar aula gratuita",
          },
        },
        {
          condition: [
            {
              step: 30,
              answer: "Internacional / Bilíngue 🌎",
            },
            {
              step: 33,
              answer: "2 ou mais dispositivos",
            },
          ],
          data: {
            typeInfo: "congrats",
            title: "🎉 Tudo pronto para a aula gratuita do seu filho!",
            subtitle:
              "No próximo passo, preencha seus dados e escolha o melhor dia e horário para ele aproveitar a aula.",
            button: "📅 Agendar aula gratuita",
          },
        },
        {
          condition: [
            {
              step: 30,
              answer: "Privada 🏫",
            },
            {
              step: 35,
              answer: "Esta semana",
            },
          ],
          data: {
            typeInfo: "congrats",
            title: "🎉 Tudo pronto para a aula gratuita do seu filho!",
            subtitle:
              "No próximo passo, preencha seus dados e escolha o melhor dia e horário para ele aproveitar a aula.",
            button: "📅 Agendar aula gratuita",
          },
        },
        {
          condition: [
            {
              step: 30,
              answer: "Internacional / Bilíngue 🌎",
            },
            {
              step: 35,
              answer: "Esta semana",
            },
          ],
          data: {
            typeInfo: "congrats",
            title: "🎉 Tudo pronto para a aula gratuita do seu filho!",
            subtitle:
              "No próximo passo, preencha seus dados e escolha o melhor dia e horário para ele aproveitar a aula.",
            button: "📅 Agendar aula gratuita",
          },
        },
        {
          condition: [
            {
              step: 31,
              answer: "Ciências ou matemática 🧪",
            },
            {
              step: 32,
              answer: "Mestrado / superior 🎓",
            },
          ],
          data: {
            typeInfo: "congrats",
            title: "🎉 Tudo pronto para a aula gratuita do seu filho!",
            subtitle:
              "No próximo passo, preencha seus dados e escolha o melhor dia e horário para ele aproveitar a aula.",
            button: "📅 Agendar aula gratuita",
          },
        },
        {
          condition: [
            {
              step: 31,
              answer: "Ciências ou matemática 🧪",
            },
            {
              step: 32,
              answer: "Licenciatura 🎓",
            },
          ],
          data: {
            typeInfo: "congrats",
            title: "🎉 Tudo pronto para a aula gratuita do seu filho!",
            subtitle:
              "No próximo passo, preencha seus dados e escolha o melhor dia e horário para ele aproveitar a aula.",
            button: "📅 Agendar aula gratuita",
          },
        },
        {
          condition: [
            {
              step: 31,
              answer: "Ciências ou matemática 🧪",
            },
            {
              step: 33,
              answer: "2 ou mais dispositivos",
            },
          ],
          data: {
            typeInfo: "congrats",
            title: "🎉 Tudo pronto para a aula gratuita do seu filho!",
            subtitle:
              "No próximo passo, preencha seus dados e escolha o melhor dia e horário para ele aproveitar a aula.",
            button: "📅 Agendar aula gratuita",
          },
        },
        {
          condition: [
            {
              step: 31,
              answer: "Ciências ou matemática 🧪",
            },
            {
              step: 35,
              answer: "Esta semana",
            },
          ],
          data: {
            typeInfo: "congrats",
            title: "🎉 Tudo pronto para a aula gratuita do seu filho!",
            subtitle:
              "No próximo passo, preencha seus dados e escolha o melhor dia e horário para ele aproveitar a aula.",
            button: "📅 Agendar aula gratuita",
          },
        },
        {
          condition: [
            {
              step: 32,
              answer: "Mestrado / superior 🎓",
            },
            {
              step: 33,
              answer: "2 ou mais dispositivos",
            },
          ],
          data: {
            typeInfo: "congrats",
            title: "🎉 Tudo pronto para a aula gratuita do seu filho!",
            subtitle:
              "No próximo passo, preencha seus dados e escolha o melhor dia e horário para ele aproveitar a aula.",
            button: "📅 Agendar aula gratuita",
          },
        },
        {
          condition: [
            {
              step: 32,
              answer: "Licenciatura 🎓",
            },
            {
              step: 33,
              answer: "2 ou mais dispositivos",
            },
          ],
          data: {
            typeInfo: "congrats",
            title: "🎉 Tudo pronto para a aula gratuita do seu filho!",
            subtitle:
              "No próximo passo, preencha seus dados e escolha o melhor dia e horário para ele aproveitar a aula.",
            button: "📅 Agendar aula gratuita",
          },
        },
        {
          condition: [
            {
              step: 32,
              answer: "Mestrado / superior 🎓",
            },
            {
              step: 35,
              answer: "Esta semana",
            },
          ],
          data: {
            typeInfo: "congrats",
            title: "🎉 Tudo pronto para a aula gratuita do seu filho!",
            subtitle:
              "No próximo passo, preencha seus dados e escolha o melhor dia e horário para ele aproveitar a aula.",
            button: "📅 Agendar aula gratuita",
          },
        },
        {
          condition: [
            {
              step: 32,
              answer: "Licenciatura 🎓",
            },
            {
              step: 35,
              answer: "Esta semana",
            },
          ],
          data: {
            typeInfo: "congrats",
            title: "🎉 Tudo pronto para a aula gratuita do seu filho!",
            subtitle:
              "No próximo passo, preencha seus dados e escolha o melhor dia e horário para ele aproveitar a aula.",
            button: "📅 Agendar aula gratuita",
          },
        },
        {
          condition: [
            {
              step: 33,
              answer: "2 ou mais dispositivos",
            },
            {
              step: 35,
              answer: "Esta semana",
            },
          ],
          data: {
            typeInfo: "congrats",
            title: "🎉 Tudo pronto para a aula gratuita do seu filho!",
            subtitle:
              "No próximo passo, preencha seus dados e escolha o melhor dia e horário para ele aproveitar a aula.",
            button: "📅 Agendar aula gratuita",
          },
        },

        {
          default: true,
          data: {
            typeInfo: "noButton",
            title: "Obrigado por confiar na nossa plataforma educacional!",
            subtitle:
              "Infelizmente, neste momento não podemos concluir seu cadastro para as aulas. Se tiver alguma dúvida, você pode nos escrever para o e-mail: social@kodland.org.<br>Esperamos poder te ajudar em breve!",
          },
        },
      ],
    },
    38: {
      title: "Inscreva-se em uma aula experimental",
      type: "one-page-contacts",
      subtitle:
        "Veja como seu filho pode começar a programar com a nossa ajuda.",
      button: "Quase lá! 🔥",
    },
    39: {
      title: "",
      type: "timeslot",
      subtitle: "",
      button: "",
    },
    40: {
      title: "Obrigado 🎉 Faltam apenas alguns passos para concluir o cadastro",
      typeInfo: "pc-laptop",
      subtitle:
        "Por favor, observe que você precisará de um PC ou laptop funcional para a aula e que deve acompanhar seu filho durante toda a aula. Lembre-se de que a aula é individual e personalizada.",
      button: "O que mais?",
    },
    41: {
      title: "Verifique seu e-mail e WhatsApp antes da aula experimental 📞",
      typeInfo: "whatsapp",
      subtitle:
        "Enviaremos um lembrete 24 horas antes da aula e 2 horas antes da aula pediremos para você confirmar sua presença. É muito importante que mantenhamos contato para que a aula não seja cancelada.",
      button: "O que mais?",
    },
    42: {
      title: "A aula vai acontecer na nossa plataforma 💻",
      typeInfo: "classroom",
      subtitle:
        "Você vai receber um link e um código único pelo WhatsApp e e-mail. Basta clicar no link, ele vai te levar direto para a aula. Sem aplicativos extras, sem downloads.",
      button: "Entendi ✅",
    },
  },
};
